import * as Yup from 'yup';
import * as message from '../../../constant/message';

export const stateSchema = Yup.object().shape({
  title: Yup.string().required(message.TERM_REQUIRED),
  description: Yup.string().required(message.DESCRIPTION_REQUIRED),
});
